var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.5 1.5 2.5 1.5 4 4 C4.84100945 8.51086887 4.86910412 10.6090021 2.42578125 14.51953125 C0.68871706 16.7569263 -1.0969409 18.9027512 -3 21 C-7.58879467 19.47040178 -9.70808503 16.15993344 -12 12 C-12.95969146 8.05460178 -12.62585251 5.04308751 -10.5 1.5 C-6.96411027 -0.62153384 -4.02098277 -0.791013 0 0 Z M-5 7 C-5 7.66 -5 8.32 -5 9 C-4.34 9 -3.68 9 -3 9 C-3 8.34 -3 7.68 -3 7 C-3.66 7 -4.32 7 -5 7 Z ",
    fill: "#000000",
    transform: "translate(19,2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.33 0.66 5.66 1.32 6 2 C5.01 2 4.02 2 3 2 C2.67 3.65 2.34 5.3 2 7 C7.94 7 13.88 7 20 7 C19.67 5.35 19.34 3.7 19 2 C18.01 1.67 17.02 1.34 16 1 C17 0 17 0 19.5625 -0.0625 C20.7690625 -0.0315625 20.7690625 -0.0315625 22 0 C23.31626692 3.61973402 24 6.09567131 24 10 C15.42 10 6.84 10 -2 10 C-1 3 -1 3 0 0 Z ",
    fill: "#000000",
    transform: "translate(4,17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.1e4160aec6e545453bce626679ba4260.svg";
export { ForwardRef as ReactComponent };